// 转换时间戳
export const formatTimeStamp = () => {
  var date = new Date()
  var year = date.getFullYear()
  var month =
    date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return (
    {
      year,
      month,
      day,
      hour,
      minute,
      second,
    }
  )
}

// 千分位
export const getNumberFormat = (val) => {
  return (val + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// imgURL 转 Base64（失败或超时仍 resolve，避免调用方 await 永久挂起；失败时退回原始地址供 url() 直链）
export const imgURLtoBase64 = (image) => {
  if (image == null || image === '') {
    return Promise.resolve('')
  }
  const img = document.createElement('img')
  const s = String(image)
  const sep = s.includes('?') ? '&' : '?'
  img.src = s + sep + 'v=' + Math.random()
  img.crossOrigin = 'anonymous'
  return new Promise((resolve) => {
    let settled = false
    const finish = (val) => {
      if (settled) return
      settled = true
      clearTimeout(tid)
      img.onload = null
      img.onerror = null
      resolve(val)
    }
    const tid = setTimeout(() => finish(s), 15000)
    img.onload = function () {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, img.width, img.height)
        finish(canvas.toDataURL('image/png', 0.1))
      } catch (e) {
        finish(s)
      }
    }
    img.onerror = function () {
      finish(s)
    }
  })
}

// Base64 转 File
export const dataURLtoFile = (dataurl, filename) => {
  return blobToFile(dataURLtoBlob(dataurl), filename)
}

// base64 转 Blob
export const dataURLtoBlob = (dataurl) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

// Blob 转 File
export const blobToFile = (blob, fileName) => {
  return new File([blob], fileName, { type: blob.type })
  // theBlob.lastModifiedDate = new Date()
  // theBlob.name = fileName
  // return theBlob
}

// 随机字符串
export const randomString = () => {
  return Math.random().toString(36).slice(-6)
}

// 16进制颜色转 rgba
export const hexToRgba = (hex, opacity) => {
  return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
}

/**
 * 数据类型判断
 * @param {*} value
 * @returns
 */
export const toRawType = (value) => {
  return Object.prototype.toString.call(value).slice(8, -1)
}

/**
 * 只能去除<对象/数组>中值为字符串或者对象/数组嵌套内值为字符串的首尾空格
 * 直接传入 String 等非引用类型，修改无法反应到外界值
 * @param {*} value
 */
export const trimStrings = (value) => {
  const valueType = toRawType(value)
  if (valueType === 'Object') {
    for (const key in value) {
      const rawType = toRawType(value[key])
      if (rawType === 'String') {
        value[key] = value[key].trim()
      } else if (rawType === 'Object' || rawType === 'Array') {
        trimStrings(value[key])
      }
    }
  } else if (valueType === 'Array') {
    value.forEach((item, i) => {
      const rawType = toRawType(value[i])
      if (rawType === 'String') {
        value[i] = value[i].trim()
      } else if (rawType === 'Object' || rawType === 'Array') {
        trimStrings(value[i])
      }
    })
  }
}
